<template>
  <v-dialog v-model="visible" max-width="500" ref="dialog" persistent>
    <v-card class="px-5 pt-5">
      <div>
        <v-text-field
          v-model="searchText"
          outlined
          dense
          hide-details
          :placeholder="$t('holidays.searchHolidays')"
        />
        <v-checkbox
          v-model="selectAll"
          @change="selectAllChanged"
          :label="selectAllLabel"
          class="font-weight-bold my-1"
          hide-details
          dense
        ></v-checkbox>
        <v-checkbox
          v-for="holiday in filteredHolidays"
          :key="holiday.date"
          :label="`${holiday.localName}`"
          v-model="selectedHolidays"
          :value="holiday"
          @input="updateSelectedHolidays"
          :disabled="isHolidayDisabled(holiday)"
          hide-details
          dense
        ></v-checkbox>
        <p v-if="holidays.length === 0">{{ $t("holidays.noHolidaysFound") }}</p>
      </div>
      <v-card-actions class="d-flex justify-space-between pa-0">
        <div class="my-4">
          <v-btn @click="closeDialog" class="bt-exit">{{
            $tc("commons.cancel")
          }}</v-btn>
        </div>
        <v-btn @click="handleAccept" class="bt-acept">{{
          $tc("commons.add")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import holidays from "@/store/gruposDeFeriados/holidays";

export default {
  props: {
    title: String,
    visible: Boolean,
    year: Number,
  },
  data() {
    return {
      searchText: "",
      holidays: [],
      selectedHolidays: [],
      selectAll: false,
    };
  },
  computed: {
    filteredHolidays() {
      return this.holidays.filter((holiday) => {
        return holiday.localName
          .toLowerCase()
          .includes(this.searchText.toLowerCase());
      });
    },
    selectAllLabel() {
      return this.selectAll
        ? this.$t("commons.deselectAll")
        : this.$t("commons.selectAll");
    },

    isHolidayDisabled() {
      return (holiday) => {
        const isDisabled = holidays.state.holidays.some((h) => {
          const hDateSubstring = h.date.substring(0, 5);
          const holidayDateSubstring =
            holiday.date.substring(8, 10) + "-" + holiday.date.substring(5, 7); // Extraer DD-MM

          const isSameDate = hDateSubstring === holidayDateSubstring;
          const isSameFullDate = h.date === holiday.date;
          const isFixed = h.fixed;

          const isDisabled = (isSameDate && isFixed) || isSameFullDate;
          return isDisabled;
        });

        return isDisabled;
      };
    },
  },

  async created() {
    await holidays.dispatch("getHolidaysNager", this.year).then(() => {
      this.holidays = holidays.state.holidaysNager;
      this.identifyCarnivalDays();
      this.isHolidayMutable();
    });
  },
  methods: {
    isHolidayMutable() {
      this.holidays.forEach((holiday) => {
        if (holiday.fixed === false) {
          holiday.localName += ` ${this.year}`;
        }
      });
    },
    async closeDialog() {
      await new Promise((resolve) => {
        this.$emit("close");
        setTimeout(() => {
          this.selectedHolidays = [];
          resolve();
        }, 1000);
      });
    },
    showSnackbar(text, color) {
      this.$emit("showSnackbar", text, color);
    },

    identifyCarnivalDays() {
      let carnivalCounter = 1;
      for (const holiday of this.holidays) {
        if (holiday.localName === "Carnaval") {
          holiday.localName += ` ${carnivalCounter}`;
          carnivalCounter++;
        }
      }
    },
    updateSelectedHolidays() {
      this.$emit("selectedHolidaysChanged", this.selectedHolidays);
    },

    handleAccept() {
      holidays.commit("setNewHolidays", this.selectedHolidays);
      holidays.dispatch("addHolidays").then(() => {
        holidays.dispatch("getHolidays");
        this.closeDialog();
        this.showSnackbar(
          this.$tc("holidayGroups.addHolidayGroupAlert"),
          "#82A1D0"
        );
      });
    },
    selectAllChanged() {
      // Filtrar solo los feriados habilitados (no deshabilitados)
      const enabledHolidays = this.filteredHolidays.filter(
        (holiday) => !this.isHolidayDisabled(holiday)
      );
      if (this.selectAll) {
        this.selectedHolidays = enabledHolidays.slice();
      } else {
        this.selectedHolidays = [];
      }
    },
  },
};
</script>
<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.bt-primary {
  border-radius: 10px !important;
  background-color: #82a1d0 !important;
  color: white !important;
}
</style>
